var exports = {
  "kL": "x7be19a29--0a37b7--container",
  "Qq": "x7be19a29--0a37b7--text",
  "SL": "x7be19a29--0a37b7--text--limited",
  "Tj": "x7be19a29--0a37b7--sources",
};

module.exports = exports;
